import { Empty } from "components/Empty/Empty";

type Props = {
    states: any;
    loading: boolean
};

export const Loading = ({
    states,
    loading,
}: Props) => {
    return (
        <>
            {!loading && !states.length && (
                <div className="m-auto">
                    <Empty />
                </div>
            )}

            {loading && (
                <div className="flex items-center justify-center w-full h-full absolute overflow-hidden bg-bgLight/50 ">
                    <div className="spinner" />
                </div>
            )}
        </>
    )
}